import request from '@/sheep/request';

// 分类
export interface Category {
	id : string
	name : string
	icon : string
	picUrl ?: string
	wishTotal ?: string
	description ?: string
}


// 查询分类列表
export const getSignStatus = () => {
	return request({
		url: '/wish/sign/status',
		method: 'GET',
	});
}

export const doSignIn = () => {
	return request({
		url: '/wish/sign/do',
		method: 'POST',
		custom: {
			auth: true,
			showLoading: true,
		},
	});
}
